import $ from 'jquery';

// Class 
class FullScreenModal{
    constructor($root){
        this.$root = $root;
        this.$form = this.$root.querySelector('.full-screen-modal__form');

        this.bind();
    }

    bind() {
        if (!this.$form) return;

        this.$form.addEventListener('submit', (e) => {
            this.handleFormSubmit(e);
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const $selectedOption = this.$form.querySelector('input[name="affiliate"]:checked');

        if ($selectedOption) {
            const value = $selectedOption.value;
            console.log("Selected Value:", value);

            // if(value === 'professional-eu') {
            //     document.cookie = `is_healthcare_professional_eu=true; path=/; max-age=31536000`;

            //     // window.location.href = '/products/';
            // }

            if(value === 'professional-us') {
                document.cookie = `is_healthcare_professional_eu=false; path=/; max-age=31536000`;

                const $form = this.$root.querySelector('.full-screen-modal__form');
                $form.style.display = 'none';

                const $message = this.$root.querySelector('.full-screen-modal_large-text');
                $message.style.display = 'block';
            } else if (value === 'patient') {
                document.cookie = `is_healthcare_professional_eu=false; path=/; max-age=31536000`;
                window.location.href = 'https://www.safeheal.com/';
            } else {
                document.cookie = `is_healthcare_professional_eu=true; path=/; max-age=31536000`;

                const url = $selectedOption.value;
                window.location.href = url;
            }
        } else {
            console.log("No option selected");
        }
    }
}

$( function(){
    const modalRoot = document.querySelector('.full-screen-modal');
    new FullScreenModal(modalRoot);
} );
